import { DropDownBox, DropDownBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../state/standardLoanStore';
import { useBfiEmployeesQuery } from '../queries/bfiEmployeesQueries';

/** Optional: the "(None)" row clears it, like the blank option in the old select. */
export const UnderwriterField = () => {
    const value = useStandardLoanStore((state) => state.setup.underwriterId);
    const { data: employees = [] } = useBfiEmployeesQuery();
    const updateSetup = useStandardLoanStore((state) => state.updateSetup);

    return (
        <DropDownBox
            id='setupUnderwriterId'
            value={value || null}
            onChange={(underwriterId: string | null) => updateSetup({ underwriterId: underwriterId ?? '' })}
            label='Underwriter'
            dataSource={[{ key: '', name: '(None)' }, ...employees]}
            displayExpr='name'
            valueExpr='key'
            placeholder='Select'
            width='100%'
            height='36px'
            layoutStyle={DropDownBoxLayoutStyle.Horizontal}
            labelWidth='100px'
        />
    );
};
